import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import { Card, Alert } from "reactstrap";
import Layout from "../../components/Wrappers/Layout";
import BackButton from "../../components/BackButton/BackButton";
import { useSelector, useDispatch } from "react-redux";
import {
	getAllWalletsList,
	resetGetAllWalletsList
} from "../../redux/actions/getAllWalletsListAction";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";

// import Tooltip from "@mui/material/Tooltip";
// import EditIcon from "@mui/icons-material/Edit";
import EditIcon from "@mui/icons-material/Edit";
// import { makeStyles } from "@mui/styles";
import { makeStyles } from "@mui/styles";
import LoadingSpinner from "../../components/LoadingSpinner/spinner.css";
import "../../components/LoadingSpinner/spinner.css";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { NavLink, Link, useHistory, useNavigate } from "react-router-dom";
// import { AiOutlineSearch } from "react-icons/ai";
import Util from "../../validation";
import SearchIcon from "@mui/icons-material/Search";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";

//new
import {
	getRegenerateToken,
	resetRegenerateToken,
  } from "../../redux/actions/regenerateTokenAction";
 


const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const FeeWallet = () => {
	const [isLoading, setIsLoading] = useState(false);
	const classes = useStyles();
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [page, setPage] = useState(0);
	const [currency, setcurrency] = useState("");
	const [notificationOpen, setNotificationOpen] = useState(false);
	const [walletName, setwalletName] = useState("");
	const dispatch = useDispatch();

	const [getAllWalletsListStatus, setgetAllWalletsListStatus] = useState(false);
	const [getAllWalletsListResArray, setgetAllWalletsListResArray] =
		useState("");

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const adminCurrencyLists = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);

	const getAllWalletsListRes = useSelector(
		({ getAllWalletsList }) => getAllWalletsList
	);

	// console.log("getAllWalletsListRes", getAllWalletsListRes);

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};
	// useEffect(() => {
	//   resetGetAllWalletsList();
	// }, [])

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	// console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const handleChange = ({ target: { name, value } }) => {
		if (name === "currency") {
			setcurrency(value == "Select Currency" ? "" : value);
		}

		if (name === "walletName") {
			// setwalletName(value);
			Util.verifyAlphabet(value)
				? setwalletName(value)
				: setwalletName(walletName);
		}
	};

	const getAllWalletsListApi = () => {
		// setIsLoading(true);
		setgetAllWalletsListStatus(true);
		const req = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				customerId: "",
				customerName: "",
				currency: currency,
				walletType: "owner",
				walletName: walletName
			}
		};
		return dispatch(getAllWalletsList(req, authToken));
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success"  && currency && walletName ) {
			getAllWalletsListApi();
		}
	}, [regenerateTokenRes.data.status]);

	const getAllWalletsListStatusFunc = () => {
		if (getAllWalletsListStatus) {
			if (getAllWalletsListRes.data.status == "success") {
				// setIsLoading(false);
				setgetAllWalletsListResArray(
					[].concat(getAllWalletsListRes.data.walletMasterReVOList)
				);
			}
			if (getAllWalletsListRes.data.status == "Failed") {
				NotificationPopups("error", "Failed", getAllWalletsListRes.data.description)
				// setIsLoading(false);
				setgetAllWalletsListResArray(getAllWalletsListRes.data);
				if (
					getAllWalletsListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getAllWalletsListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getAllWalletsListRes.data.status == "failed") {
				NotificationPopups("error", "Failed", getAllWalletsListRes.data.description)
				// setIsLoading(false);
				setgetAllWalletsListResArray(getAllWalletsListRes.data);
				if (
					getAllWalletsListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getAllWalletsListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getAllWalletsListRes.data.status == "NOT FOUND") {
				// setIsLoading(false);
				setgetAllWalletsListStatus(false);
				setgetAllWalletsListResArray(getAllWalletsListRes.data);
				NotificationPopups("error", "Failed", getAllWalletsListRes.data.status)
			}
		}
	};

	useEffect(() => {
		if (getAllWalletsListRes.data.status) {
			getAllWalletsListStatusFunc();
		}
	}, [getAllWalletsListRes.data.status]);

	useEffect(() => {
		if (getAllWalletsListRes.data.status == "success") {
			setPage(0);
		}
	}, [getAllWalletsListRes.data.status]);

	// useEffect(() => {
	//   if (getAllWalletsListRes.data.status == "success") {
	//     setIsLoading(true);
	//     getAllWalletsListResFunc();
	//   }
	// }, [getAllWalletsListRes.data.status]);

	// const getAllWalletsListResFunc = () => {
	//   if (getAllWalletsListStatus) {
	//     setIsLoading(false);
	//     if (getAllWalletsListRes.data.status == "success") {
	//       setgetAllWalletsListResArray(
	//         [].concat(getAllWalletsListRes.data.walletMasterReVOList)
	//       );
	//     }
	//     if (getAllWalletsListRes.data.status == "Failed") {
	//       setgetAllWalletsListResArray(getAllWalletsListRes.data);
	//     }
	//   }
	// };

	return (
		<>
			<Layout>
				<Card>
					{/* <BackButton /> */}
					<Grid
						container
						style={{ padding: "25px", gap: "20px", justifyContent: "right" }}
					>
						{/* <Grid item md={7} sm={12} lg={5}></Grid> */}
						<Grid item md={3} sm={12} xs={12} lg={3}>
							<NavLink to="/index/addNewFeeWallet">
								{/* <Button
                  variant="contained"
                  style={{ backgroundColor: "#00b9f5", color: "white" }}
                  size="small"
                >
                  Add New Fee Wallet
                </Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
								>
									Add New Fee Wallet
								</CustomButton>
							</NavLink>
						</Grid>
					</Grid>

					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								select
								// required
								autoFocus
								margin="dense"
								id="name"
								label="Currency"
								fullWidth
								variant="standard"
								type="text"
								name="currency"
								// value={currency || ""}
								defaultValue={"Select Currency" || currency}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="Select Currency" selected="Select Currency">
									Select Currency
								</MenuItem>
								{adminCurrencyLists.success &&
									[]
										.concat(adminCurrencyLists.data.currencyList)
										.map((x) => <MenuItem value={x}>{x}</MenuItem>)}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Wallet Name"
								type="text"
								fullWidth
								variant="standard"
								name="walletName"
								value={walletName || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</Grid>
						<Grid
							item
							xs={12}
							sm={12}
							md={4}
							lg={4}
							style={{
								padding: "10px",
								marginTop: "0.5rem",
								marginBottom: "15px"
							}}
						>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={getAllWalletsListApi}
							>
								Search <SearchIcon />
							</CustomButton>
							{/* <Button
                style={{
                  marginLeft: "0.7rem",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                endIcon={<AiOutlineSearch />}
                variant="contained"
                onClick={getAllWalletsListApi}
              >
                Search
              </Button> */}
						</Grid>
					</Grid>
				</Card>

				{getAllWalletsListResArray.length == undefined ||
					!getAllWalletsListStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Wallet List
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
									style={{ color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Wallet List
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table className={classes.table}>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Wallet ID{" "}
											</TableCell>
											{/* <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Customer/Merchant ID{" "}
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Customer/Merchant Name
                      </TableCell> */}
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Wallet Name
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Currency
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Balance
											</TableCell>
											{/* <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Action
                      </TableCell> */}
										</TableRow>
									</TableHead>

									<TableBody>
										{getAllWalletsListResArray &&
											[]
												.concat(getAllWalletsListResArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow key={row.index}>
														<TableCell align="center">{row.walletId}</TableCell>
														{/* <TableCell align="center">
                              {row.customerId}
                            </TableCell>
                            <TableCell align="center">{row.custName}</TableCell> */}
														<TableCell align="center">
															{row.walletName}
														</TableCell>
														<TableCell align="center">
															{row.walletCurrency}
														</TableCell>
														<TableCell align="center">
															{row.walletBalance}
														</TableCell>
														{/* <TableCell align="center">
                              <Tooltip title="Edit">
                                <CustomButton
                                  style={{
                                    padding: "8px",
                                  }}
                                onClick={() =>
                                  editGetCustomerIdAndName(
                                    row.walletName,
                                    row.customerId,
                                    row.walletId,
                                    row.walletCurrency,
                                    row.custName
                                  )
                                }
                                >
                                  Edit
                                  {
                                    <EditIcon
                                      style={{
                                        color: "#fff",
                                        fontSize: "20px",
                                      }}
                                    />
                                  }
                                </CustomButton>
                              </Tooltip>
                            </TableCell> */}
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={getAllWalletsListResArray.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}
			</Layout>

			{/* <div>
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Edit Customer/Merchant Wallet</DialogTitle>
          <DialogContent>
            <TextField
              // defaultValue={"Select Currency"}
              size="small"
              color="primary"
              autoFocus={true}
              type="text"
              label="Customer/Merchant ID*"
              value={editCustomerMerchantID}
              name="editCustomerMerchantID"
              fullWidth={true}
              select
              onChange={handleChange}
            >
              {(() => {
                if (getCustomerIdAndNameListRes) {
                  if (!getCustomerIdAndNameListRes.data.currencyList) {
                    return <MenuItem>No Customer/Merchant ID</MenuItem>;
                  }
                  return []
                    .concat(getCustomerIdAndNameListRes.data.currencyList)
                    .map((c) => (
                      <MenuItem value={c} key={c}>
                        {c}
                      </MenuItem>
                    ));
                }
              })()}
            </TextField>

            <TextField
              select
              required
              size="small"
              color="primary"
              autoFocus={true}
              type="text"
              label="Currency"
              fullWidth={true}
              name="editCurrency"
              value={editCurrency || ""}
              onChange={handleChange}
            >
              {adminCurrencyList.success &&
                adminCurrencyList.data.currencyList.map((x) => (
                  <MenuItem value={x}>{x}</MenuItem>
                ))}
            </TextField>

            <TextField
              margin="dense"
              id="name"
              label="Wallet Name"
              type="name"
              fullWidth
              variant="standard"
              value={walletName || ""}
              name="walletName"
              onChange={handleChange}
            />
          </DialogContent>
          <DialogActions>
            <Button
              style={{
                backgroundColor: "#fff",
                color: "#000",
              }}
              variant="contained"
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              style={{
                backgroundColor: "#00b9f5",
                color: "white",
              }}
              variant="contained"
              onClick={updateCustomerWallet}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </div> */}

			{/* {updateCustomerWalletListArray.status == "success" && (
        <div>
          <Dialog open={notificationOpen} onClose={handleNoticationClose}>
            <DialogContent
              className="text-center"
              style={{ backgroundColor: "#00b9f51c" }}
            >
              <img src={success} alt="" width="100px" className="my-2" />
            </DialogContent>
            <DialogContent>
              <h4
                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
              >
                {updateCustomerWalletListArray.description}
              </h4>
            </DialogContent>
            <DialogActions style={{ justifyContent: "center" }}>
              <Button
                style={{
                  margin: "10px 0",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                onClick={handleNoticationClose}
              >
                Ok
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}

      {updateCustomerWalletListArray.status == "Failed" && (
        <div>
          <Dialog open={notificationOpen} onClose={handleNoticationClose}>
            <DialogContent
              className="text-center"
              style={{ backgroundColor: "#00b9f51c" }}
            >
              <img src={failed} alt="" width="100px" className="my-2" />
            </DialogContent>
            <DialogContent>
              <h4
                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
              >
                {updateCustomerWalletListArray.result.description}
              </h4>
            </DialogContent>
            <DialogActions style={{ justifyContent: "center" }}>
              <Button
                style={{
                  margin: "10px 0",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                onClick={handleNoticationClose}
              >
                Ok
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )} */}
		</>
	);
};

export default FeeWallet;
